import { ViewType } from '~/models/shared/types'
import { CategoryId } from '~/models/category/types'

export const vehiclesSearchConfig = {
  create(name: string) {
    // Workaround for commercials due to key mismatch
    // CategoryId.COMMERCIAL vs 'commercials' in route params
    const categoryId =
      name === 'commercials'
        ? CategoryId.COMMERCIAL
        : CategoryId[name.toUpperCase() as keyof typeof CategoryId]

    return {
      settings: {
        searchName: name,
        viewType: {
          defaultViewTypeDesktop: ViewType.LIST,
          defaultViewTypeMobile: ViewType.LIST
        },
        searchbar: {
          autocompleteEndpoint: '/api/classifieds/query/',
          usesNuxtLinks: true
        },
        stats: {
          record: true
        },
        isVehiclesSearch: true,
        displayAds: true
      },
      rootParams: {
        // TODO: that's a bit too fragile, maybe change later
        category: [categoryId]
      }
    }
  }
}
